<template>
	<div class="wrapper page-container scroll-view" style="overflow: auto">
		<div class="todayData">
			<div class="dataWarp">
				<div class="data_item" v-for="(item, index) in todayArr" :key="index">
					<div>{{ item.tit }}</div>
					<div>{{ item.val }}</div>
				</div>
			</div>
		</div>
		<div class="data_cart_warp">
			<div class="nav_warp">
				<div class="nav_item" :class="index == 0 ? 'nav_item_ac' : ''" @click="navClick(0)">
					<span>未收款客户</span>
					<div v-if="index == 0" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 1 ? 'nav_item_ac' : ''" @click="navClick(1)">
					<span>对账单记录</span>
					<div v-if="index == 1" class="nav_item_line"></div>
				</div>
			</div>
			<div class="custUpWarp" v-show="index == 0">
				<div class="top_content">
					<div class="tabs">
						<span style="width: 70px;">选择客户：</span>
						<div class="top_input3">
							<el-select v-model="checkTypeValue" filterable placeholder="请选择" v-if="checkType!=='1'"
								clearable>
								<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
									:value="item.index">
								</el-option>
							</el-select>
							<el-input type="text" placeholder="请输入" v-model="searchWord"
								v-if="checkType=='1'"></el-input>
						</div>
						<div
							style="display: flex;width: 230px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;padding: 0 10px;">
							对帐状态：
							<el-select style="width: 150px; height: 35px" v-model="checkCostStatus" placeholder="请选择">
								<el-option label="全部" value=""> </el-option>
								<el-option label="已对账" value="0"> </el-option>
								<el-option label="未对账" value="1"> </el-option>
							</el-select>
						</div>
						<div
							style="display: flex;width: 350px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;">
							计划装货时间：
							<el-date-picker style="width: 250px; height: 35px" v-model="pLoaddayArr"
								type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
								clearable format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
							</el-date-picker>
						</div>
						<div
							style="display: flex;width: 350px; height: 35px;align-items: center;justify-content: flex-start;">
							卸货离站时间：
							<el-date-picker style="width: 250px; height: 35px" v-model="sUnlonddayArr"
								type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
								clearable format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
							</el-date-picker>
						</div>
						<div class="search_btn" @click="getData()">查询</div>
						<div class="add_btn" @click="handleAudits()">生成对账单</div>
						<div class="search_btn" @click="exportClick()" v-if="permissionItem.export">导出</div>

					</div>
					<!-- <div class="close_button">
						<el-popover :visible="popoverVisible" @show="showPopover" placement="bottom" trigger="click"
							:width="200">
							<div style="max-height: 300px; overflow-y: auto;">
								<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
									@change="handleCheckAllChange">全选</el-checkbox>
								<div style="margin: 10px 0;"></div>
								<el-checkbox-group v-model="checkedColumns" @change="handleCheckedColumnsChange"
									style="display: flex;flex-direction: column;">
									<el-checkbox v-for="column in columns" :label="column.lable"
										:key="column.lable">{{column.lable}}</el-checkbox>
								</el-checkbox-group>
							</div>
							<div style="text-align: right; margin: 0">
								<el-button size="small" text @click="popoverVisible = false">取消</el-button>
								<el-button size="small" type="primary" @click="confirmPopover">
									确认
								</el-button>
							</div>
							<template #reference>
								<div @click="popoverVisible = true">
									<i class="iconfont icon-shezhi"> 列设置</i>
								</div>
							</template>
						</el-popover>
					</div> -->
				</div>
				<div class="bottom_content">
					<div class="table_container" v-bind:id="tableId">
						<el-table v-bind:data="tableData" stripe border style="width: 100%"
							v-bind:max-height="tableHeight" v-bind:header-cell-style="{
							  textAlign: 'center',
							  color: '#333333',
							  background: '#F5F5F5',
							}" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
							<el-table-column type="selection"> </el-table-column>
							<el-table-column fixed prop="vehHeadNo" label="对账状态" width="100">未对账</el-table-column>
							<el-table-column fixed prop="lorId" label="运单号" width="120"
								v-if="showColumn('运单号')"></el-table-column>
							<el-table-column fixed prop="shipperName" label="托运商" width="120"
								v-if="showColumn('托运商')"></el-table-column>
							<el-table-column fixed prop="lorVehHeadNo" label="牵引车辆" width="120"
								v-if="showColumn('牵引车辆')"></el-table-column>
							<el-table-column prop="lorLoadName" label="装货地" width="120"
								v-if="showColumn('装货地')"></el-table-column>
							<el-table-column prop="unloadList[0].lorlUnlName" label="卸货地" width="120"
								v-if="showColumn('卸货地')"></el-table-column>
							<el-table-column prop="lorFreightMilage" label="运费里程(KM)" width="120"
								v-if="showColumn('运费里程(KM)')"></el-table-column>
							<el-table-column prop="lorFreightWeight" label="运费吨位(吨)" width="120"
								v-if="showColumn('运费吨位(吨)')"></el-table-column>
							<el-table-column prop="lorFreightPrice" label="运费单价(元/吨/公里)" width="120"
								v-if="showColumn('运费单价(元/吨/公里)')"></el-table-column>
							<el-table-column prop="lorFreightMoney" label="运费收入(元)" width="120"
								v-if="showColumn('运费收入(元)')"></el-table-column>
							<el-table-column prop="lorOccupyIncome" label="压车费收入(元)" width="120"
								v-if="showColumn('压车费收入(元)')"></el-table-column>
							<el-table-column prop="lorUnloadIncome" label="分卸费收入(元)" width="120"
								v-if="showColumn('分卸费收入(元)')"></el-table-column>
							<el-table-column prop="lorSumIncome" label="总收入(元)" width="120"
								v-if="showColumn('总收入(元)')"></el-table-column>
							<el-table-column prop="lorLoadsWeightSum" label="实际装货吨位" width="120"
								v-if="showColumn('实际装货吨位')"></el-table-column>
							<el-table-column prop="lorUnlsWeightSum" label="实际卸货吨位" width="120"
								v-if="showColumn('实际卸货吨位')"></el-table-column>
							<el-table-column prop="lorLossWeightSum" label="途损吨位" width="120"
								v-if="showColumn('途损吨位')"></el-table-column>
							<el-table-column prop="lorLoadType" label="单/分卸" width="120" v-if="showColumn('单/分卸')">
								<template #default="scope">
									<span v-if="scope.row.lorLoadType == '0'">单装单卸</span>
									<span v-else-if="scope.row.lorLoadType == '1'">单装分卸</span>
									<span v-else>--</span>
								</template>
							</el-table-column>
							<el-table-column prop="lorGoods" label="货品" width="120" v-if="showColumn('货品')">
								<template #default="scope">
									<span v-if="scope.row.lorGoods == '1'">LNG</span>
									<span v-else-if="scope.row.lorGoods == '2'">CNG</span>
									<span v-else>--</span>
								</template>
							</el-table-column>
							<el-table-column prop="odrMDirName" label="驾驶员" width="120"
								v-if="showColumn('驾驶员')"></el-table-column>
							<el-table-column prop="odrYayunName" label="押运员" width="120"
								v-if="showColumn('押运员')"></el-table-column>
							<!-- <el-table-column prop="roleCretime" label="创建时间" width="120"></el-table-column> -->
							<el-table-column label="操作" fixed="right" width="150px">
								<template #default="scope">
									<!-- 	<span class="default_color pointer m-right10" v-on:click="edit(scope.row.roleId)">编辑</span> -->
									<span class="default_color pointer m-right10"
										v-on:click="detail1(scope.row.lorId)">详情</span>
									<span class="default_color pointer m-right10"
										v-on:click="edit(scope.row.lorId)">调账</span>	
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="flex flex-y-center flex-x-center m-top20">
						<el-config-provider :locale="locale">
							<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
								:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
								:total="totalCount" @size-change="getData" @current-change="getData" />
						</el-config-provider>
					</div>
				</div>
			</div>

			<div v-show="index==1" style="width: 100%;">
				<div class="top_content">
					<div class="tabs">
						<span style="width: 70px;">选择客户：</span>
						<div class="top_input3">
							<el-select v-model="checkTypeValue" filterable placeholder="请选择" v-if="checkType!=='1'"
								clearable>
								<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
									:value="item.index">
								</el-option>
							</el-select>
							<el-input type="text" placeholder="请输入" v-model="searchWord"
								v-if="checkType=='1'"></el-input>
						</div>
						<div
							style="display: flex;width: 320px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;padding: 0 10px;">
							对账时间：
							<el-date-picker style="width: 250px; height: 35px" v-model="pLoaddayArr"
								type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
								clearable format="YYYY-MM-DD" value-format="YYYY-MM-DD">
							</el-date-picker>
						</div>
						<div
							style="display: flex;width: 230px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;padding: 0 10px;">
							付款状态：
							<el-select style="width: 150px; height: 35px" v-model="checkCostStatus" placeholder="请选择">
								<el-option label="全部" value=""> </el-option>
								<el-option label="已付款" value="0"> </el-option>
								<el-option label="未付款" value="1"> </el-option>
							</el-select>
						</div>
						<div class="top_input3">
							<el-input type="text" placeholder="请输入单号" v-model="searchWord"></el-input>
						</div>
						<div class="search_btn" @click="getData()">查询</div>
						<div class="search_btn" @click="exportClick()" v-if="permissionItem.export">导出</div>

					</div>
					<div class="close_button">
						<el-popover :visible="popoverVisible" @show="showPopover" placement="bottom" trigger="click"
							:width="200">
							<div style="max-height: 300px; overflow-y: auto;">
								<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
									@change="handleCheckAllChange">全选</el-checkbox>
								<div style="margin: 10px 0;"></div>
								<el-checkbox-group v-model="checkedColumns" @change="handleCheckedColumnsChange"
									style="display: flex;flex-direction: column;">
									<el-checkbox v-for="column in columns" :label="column.lable"
										:key="column.lable">{{column.lable}}</el-checkbox>
								</el-checkbox-group>
							</div>
							<div style="text-align: right; margin: 0">
								<el-button size="small" text @click="popoverVisible = false">取消</el-button>
								<el-button size="small" type="primary" @click="confirmPopover">
									确认
								</el-button>
							</div>
							<template #reference>
								<!-- <el-button @click="visible = true">列设置</el-button> -->
								<div @click="popoverVisible = true">
									<i class="iconfont icon-shezhi"> 列设置</i>
								</div>
							</template>
						</el-popover>
					</div>
				</div>
				<div class="bottom_content">
					<div class="table_container" v-bind:id="tableId">
						<el-table v-bind:data="tableData" stripe border style="width: 100%"
							v-bind:max-height="tableHeight" v-bind:header-cell-style="{
							  textAlign: 'center',
							  color: '#333333',
							  background: '#F5F5F5',
							}" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
							<el-table-column prop="odrId" label="对账单号" width="120"></el-table-column>
							<el-table-column prop="odrLoadpTime" label="对账对象" width="120"></el-table-column>
							<el-table-column prop="odrLoadpTime" label="对账笔数" width="120"></el-table-column>
							<el-table-column prop="vehHeadNo" label="应收金额" width="120"></el-table-column>
							<el-table-column prop="vehHeadNo" label="实际收款金额" width="120"></el-table-column>
							<el-table-column prop="vehHeadNo" label="未核销金额" width="120"></el-table-column>
							<el-table-column prop="vehHeadNo" label="收款状态" width="120"></el-table-column>
							<el-table-column prop="vehHeadNo" label="对账状态" width="120"></el-table-column>
							<!-- <el-table-column prop="vehHeadNo" label="对单状态" width="120"></el-table-column> -->
							<el-table-column prop="orgName" label="对账单附件" width="150"></el-table-column>
							<el-table-column prop="heaMilage" label="创建时间" width="300"></el-table-column>
							<el-table-column prop="loadDuration" label="创建人" width="120"></el-table-column>
							<el-table-column prop="unlDuration" label="备注" width="120"></el-table-column>
							<el-table-column label="操作" fixed="right" width="150px">
								<template #default="scope">
									<span class="default_color pointer m-right10">收款</span>
									<span class="default_color pointer m-right10" @click="detail(1)">详情</span>
									<span class="col-FF1A1A pointer">删除</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="flex flex-y-center flex-x-center m-top20">
						<el-config-provider :locale="locale">
							<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
								:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
								:total="totalCount" @size-change="getData" @current-change="getData" />
						</el-config-provider>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="对账" v-model="isAudit" width="30%" center>
			<div class="mar-bot-20"><span style="color: red">*</span>所选数据共有0单，对账单金额合计0元，是否要对所选运单进行对账？</div>
			<!-- <div style="width: 100%; height: 80px">
				<el-select v-model="lorWhid" placeholder="请选择" @change="siteLoadChange">
					<el-option v-for="(item, index) in siteList" :key="index" :label="item.whName" :value="item.whId">
						<span style="float: left">{{ item.whName }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.whType }}
						</span>
					</el-option>
				</el-select>
			</div> -->
			<div class="btn_warp">
				<div class="btn-outline1" @click="updateSitesubmit(0)">取消</div>
				<div class="btn-outline2" @click="updateSitesubmit(1)">确定</div>
			</div>
		</el-dialog>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";

	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "reconciliation",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const chartRef = ref(null);

			const data = reactive({
				tableId: "roleManagementTable",
				index: 0,
				page: 1,
				pageSize: 20,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				isAudit: false,
				todayArr: [{
						tit: "未收款客户数",
						val: 0,
					}, {
						tit: "未收款金额",
						val: 0,
					},
					{
						tit: "未收款单数",
						val: 0,
					},
					{
						tit: "已对账待收款金额",
						val: 0,
					},
					{
						tit: "待对账金额",
						val: 0,
					},
					{
						tit: "客户总数",
						val: 0,
					},
				],
				titArr: [{
						tit: "承运单量",
						type: "newUserCount",
					},
					{
						tit: "承运收入",
						type: "pubNewUserCount",
					},
				],
				titType: "newUserCount",
				titIndex: 0,
				classfyArr: [{
					tit: "全部",
					type: 0,
				}, ],
				classfyIndex: 0,
				dayArr: [],
				myUserChart1: null,
				myUserChart2: null,
				allData: [],
				userType: {},
				ddtjType: "1",
				monthStr: "",
				type: "month",
				year: "",
				month: "",
				myChart4: null,
				checkTypeValue: '',
				checkTypeList: [],
				pLoaddayArr: [],
				sUnlonddayArr: [],
				lorId: "",
				lorShipper: "",
				vehHeadNo: "",
				driverId: "",
				lorYayunId: "",
				lorLoadWhid: "",
				lorlUnlWhid: "",

				permissionItem: {
					see: false,
				},
			});

			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "homePage:see") {
						data.permissionItem.see = true;
					}
				});

				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};

				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 20;

					getData();
					getcusList();
					var d = new Date();
					var year = d.getFullYear();
					var month = d.getMonth() + 1;
					if (month < 10) {
						month = "0" + month;
					}
					data.year = year.toString();
					console.log(data.year);
					data.monthStr = year + "-" + month;
					data.month = month;

				});
			});


			//获取列表数据
			const getData = async () => {
				data.lorId = "";
				data.lorShipper = data.checkTypeValue;
				data.vehHeadNo = "";
				data.driverId = "";
				data.lorYayunId = "";
				data.lorLoadWhid = "";
				data.lorlUnlWhid = "";

				let params = {
					page: data.page,
					limit: data.pageSize,
					lorId: data.lorId, //运单号
					lorShipper: data.lorShipper, //托运商ID 必填
					vehHeadNo: data.vehHeadNo, //车牌号 必填
					driverId: data.driverId, //驾驶员ID 必填
					lorYayunId: data.lorYayunId, //押运员ID 必填
					lorLoadWhid: data.lorLoadWhid, //装货站点 必填
					lorlUnlWhid: data.lorlUnlWhid, //卸货站点ID 必填
					loadpStartTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						0] : "", //计划装货开始时间
					loadpEndTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						1] : "", //计划装货结束时间
					unlOffsiteStartTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[0] : "", //卸货离站开始时间
					unlOffsiteEndTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[1] : "", //卸货离站结束时间
				};
				const r = await proxy.$http.get(apiObj.reportOrderDetails, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					data.tableData = r.rows;
					data.totalCount = r.total;

				}
			};

			const getcusList = async () => {
				//获取托运商
				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
					cocOrg: "",
					cocType: 1,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				data.checkTypeList = [];
				if (res.code === 0 || res.respCode == "0000") {
					res.rows.forEach((el) => {
						data.checkTypeList.push({
							value: el.cocName,
							index: el.cocId,
						});
					});

				}
			};

			const initTodayArr = (today) => {
				data.todayArr.forEach((item) => {
					if (item.tit == "总车辆数") {
						item.val = today.regiVehCount;
					}
					if (item.tit == "当日营运车辆数") {
						item.val = today.todayWorkVehCount;
					}
					if (item.tit == "当日派单数") {
						item.val = today.todayAppoVehCount;
					}
					if (item.tit == "当日承运收入") {
						item.val = Math.round(today.todayOdrFreight).toLocaleString();
					}
					if (item.tit == "当月承运单量") {
						item.val = today.monthOdrCount;
					}
					if (item.tit == "当月承运收入") {
						item.val = Math.round(today.monthOdrFreight).toLocaleString();
					}
					if (item.tit == "在途吨位") {
						item.val = today.travelWeight;
					}
					if (item.tit == "在途单数") {
						item.val = today.travelOdrCount;
					}
				});
			};

			// 表格列是否显示的方法
			const showColumn = (currentColumn) => {
				return true;
				// const column = columns.value.find((item) => item.lable === currentColumn);
				// if (column) {
				// 	return column.show;
				// } else {
				// 	return false;
				// }
			};

			const navClick = (index) => {
				data.index = index;
			};

			// 菜单编辑
			const edit = (id) => {
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};

			// 菜单详情
			const detail = (id) => {
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};

			const handleAudits = () => {
				data.isAudit = true;
			};


			return {
				...toRefs(data),
				edit,
				detail,
				getData,
				navClick,
				showColumn,
				handleAudits,
			};
		},
	});
</script>

<style scoped>
	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 60px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 16px;
		color: #666666;
		line-height: 60px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 80%;
		left: 10%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.todayData {
		width: 100%;
		height: 80px;
		background: #ffffff;
	}

	.todayTit {
		width: 100%;
		height: 110px;
		line-height: 110px;
		font-size: 18px;
		color: #222222;
		text-indent: 50px;
		text-align: left;
	}

	.dataWarp {
		width: 100%;
		display: flex;
		height: 50px;
		display: flex;
		padding-top: 15px;
	}

	.data_item {
		width: 16.6%;
		height: 50px;
		border-right: 1px solid #e5e5e5;
		color: #222222;
		text-align: center;
	}

	.dataWarp>div:nth-last-child() {
		border: none;
	}

	.data_item div:nth-of-type(1) {
		font-size: 16px;
	}

	.data_item div:nth-of-type(2) {
		font-size: 20px;
		font-weight: bold;
		margin-top: 10px;
	}

	.data_cart_warp {
		width: 100%;
		height: calc(100% - 90px);
		background: #ffffff;
		margin-top: 10px;
	}

	.custUpWarp {
		width: 100%;
		height: calc(100% - 60px);
		background: #ffffff;
		margin-top: 0px;
	}


	.dataTit {
		width: 100%;
		text-align: left;
		font-size: 20px;
		text-indent: 50px;
		color: #222222;
	}

	.data_btn_warp {
		width: calc(100% - 55px);
		margin-top: 35px;
		margin-left: 55px;
		display: flex;
		padding-bottom: 34px;
		border-bottom: 1px solid #eeeeee;
	}

	.data_btn_warp div {
		padding: 0 20px;
		height: 36px;
		background: #ebebeb;
		border-radius: 7px;
		line-height: 36px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		margin-right: 25px;
	}

	.data_btn_warp>.data_btn_ac {
		color: #ffffff;
		background: #26ca67;
	}

	.data_search_warp {
		width: calc(100% - 55px);
		margin-top: 35px;
		margin-left: 55px;
		display: flex;
	}

	.classfy_warp {
		display: flex;
		margin-left: 35px;
	}

	.classfy_warp div {
		width: 90px;
		height: 42px;
		border: 1px solid #e5e5e5;
		border-radius: 21px;
		font-size: 13px;
		color: #999999;
		text-align: center;
		line-height: 42px;
		margin-right: 20px;
		cursor: pointer;
	}

	.classfy_warp .classfy_ac {
		border-color: #2eb779;
		color: #2eb779;
	}

	.chart_box1 {
		width: 100%;
		margin-top: 20px;
		height: 360px;
	}

	#myUserChart1 {
		width: 96%;
		height: 360px;
		margin-left: 2%;
	}

	.chart_box2 {
		width: 100%;
		height: 360px;
		display: flex;
		justify-content: center;
	}

	#myUserChart2 {
		width: 500px;
		height: 360px;

	}

	.table_warp {
		width: 96%;
		margin-left: 2%;
		margin-top: 20px;
		padding-bottom: 50px;
	}

	.bottom_chart_box {
		width: 100%;
		flex: 1;
		background: #ffffff;
		border-radius: 16px;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.bottom_chart_tit {
		width: 100%;
		height: 68px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.choose_btn_box {
		display: flex;
		align-items: center;
	}

	.choose_type {
		width: 63px;
		height: 34px;
		border: 1px solid #293787;
		font-size: 14px;
		color: #293787;
		text-align: center;
		line-height: 34px;
		cursor: pointer;
	}

	.choose_type_ac {
		background: linear-gradient(-60deg, #293787, #293787);
		box-shadow: 0px 4px 12px 0px rgba(65, 201, 98, 0.36);
		color: #ffffff;
	}

	.month_input {
		width: 120px;
		margin-left: 20px;
		margin-right: 20px;
	}

	:deep(.month_input .el-date-editor.el-input, .el-date-editor.el-input__inner) {
		width: 100% !important;
	}

	:deep(.month_input .el-input__inner) {
		height: 34px;
		line-height: 34px;
		border-color: #293787;
		color: #293787;
	}

	:deep(.month_input .el-icon-date) {
		color: #293787;
	}

	.bottom_chart {
		width: 100%;
		flex: 1;
	}

	.custTjItemRight {
		margin-right: 20px;
	}

	.custTjItemRight p {
		width: 85px;
		height: 34px;
		line-height: 34px;
		font-size: 14px;
		color: #c1c1c1;
		text-align: center;
		border: 1px solid #c1c1c1;
		cursor: pointer;
	}

	.custTjItemRight p:nth-child(1) {
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border-right: none;
	}

	.custTjItemRight p:nth-child(2) {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		border-left: none;
	}

	.custTjItemRight p.ac {
		background: #293787;
		color: #fff;
		border-color: #293787;
	}

	.tabs {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	.close_button {
		width: 100px;
		height: 100%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.top_content {
		width: 100%;
		height: 70px;
		padding: 0 25px;
		margin-bottom: 10px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 80px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 50px);
		height: calc(100% - 80px);
		margin: 0 auto;
		padding-top: 0px;
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}
</style>